import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useDialogStore = () => {
    return defineStore('dialogs', () => {
        const openDialogs = ref<Set<string | number>>(new Set());

        const openDialog = (dialogId: string | number): void => {
            openDialogs.value.add(dialogId);
        };

        const closeDialog = (dialogId: string | number): void => {
            openDialogs.value.delete(dialogId);
        };

        const closeAllDialogs = (): void => {
            openDialogs.value.clear();
        };

        const isDialogOpen = (dialogId: string | number): boolean => openDialogs.value.has(dialogId);

        return {
            openDialog,
            closeDialog,
            closeAllDialogs,
            isDialogOpen
        };
    });
};
